<template>
  <div class="bb-upload-form">
    <div class="bb-upload-form-file"
         :class="{'bb-upload-form-file_loading': fileNotUploaded}"
         v-if="fileReady || fileNotUploaded"
         @click="openFile">
      <i class="icon-picture" v-if="fileReady"/>
      <span class="bb-upload-form-file__loading" v-else-if="fileNotUploaded"/>
    </div>
    <div class="bb-upload-form-text"
         v-if="!disabled"
         ref="bbUploadFormText"
         @click.stop="openToolbar">
      <template v-if="fileNotSelected">
        Upload {{ currentFileName }}
        <input class="bb-upload-form-text__input"
               title=""
               ref="bbUploadFormInput"
               type="file"
               @change="processFile">
      </template>
      <template v-else-if="fileNotUploaded">
        Loading...
      </template>
      <template v-else>
        Edit {{ currentFileName }}
      </template>
    </div>
    <transition name="bounce">
      <Popup class="bb-upload-form__popup"
             @change="toolbarAction"
             :radio="false"
             title=""
             v-if="displayToolbar"
             :options="toolbarFile"
             @close="displayToolbar = false"/>
    </transition>
  </div>
</template>

<script>
import UploadFileApi from '@/api/UploadFile/api'
import setFileData from '@/mixin/setFileData'
import Popup from '@/components/Main/Popup/Popup'
import b64toBlob from 'b64-to-blob'
import { saveAs } from 'file-saver'

export default {
  name: 'UploadFileForm',
  props: ['filename', 'disabled', 'fileId'],
  mixins: [setFileData],
  components: {Popup},
  data () {
    return {
      file: {},
      displayToolbar: false,
      toolbarFile: {},
      crypt: true,
      blob: '',
      label: '',
      isNotFile: true
    }
  },
  computed: {
    currentFileName () {
      return this.filename || 'file'
    },
    fileNotSelected () {
      return !this.fileId ? this.isNotFile : false
    },
    fileNotUploaded () {
      return this.file.type && !this.file.id
    },
    fileReady () {
      return this.file.id || this.fileId
    }
  },
  methods: {
    toolbarAction (val) {
      if (val && val.func) {
        val.func()
      }
    },
    openToolbar () {
      if (this.fileReady) {
        this.displayToolbar = true
      }
    },
    setDefaultActions () {
      this.toolbarFile = [
        {id: 1, name: 'Upload new', func: this.updateFile},
        {id: 2, name: 'Remove', func: this.deleteFile},
        {id: 3, name: 'Cancel', func: () => { this.displayToolbar = false }}
      ]
    },
    updateFile () {
      this.deleteFile()
      this.$nextTick(() => {
        const inputNode = this.$refs.bbUploadFormInput || []
        if (inputNode) inputNode.click()
      })
    },
    deleteFile () {
      if (this.file.id) UploadFileApi.deleteFile(this.file.id, this.crypt)
      this.file = {}
      this.displayToolbar = false
      this.$emit('remove')
    },
    openFile () {
      if (this.file.id === this.fileId) {
        const blob = b64toBlob(this.file.base64, this.file.type)
        saveAs(blob, this.file.label)
      } else {
        const newFile = typeof this.fileId === 'string' ? this.fileId : this.file.id
        this.getFile(newFile)
      }
    },
    getFile (id) {
      this.$emit('loader', true)
      UploadFileApi.getFile(id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.file = resp.data
          saveAs(blob, resp.data.label)
          this.$emit('loader', false)
        })
        .catch(err => {
          console.error(err)
          this.$emit('loader', false)
        })
    },
    processFile (e) {
      this.isNotFile = false
      const file = e.target.files[0]
      if (!file) return
      this.file = file
      this.uploadFile(file)
      e.target.value = ''
    },
    uploadFile (fileData) {
      const file = this.setFileData(fileData)
      UploadFileApi.createFile(file, this.crypt)
        .then((resp) => {
          this.file = resp.data
          this.$emit('upload', this.file)
        })
        .catch((err) => {
          this.file = {}
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.setDefaultActions()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bb-upload-form {
  @include global-font;
  position: relative;
  display: flex;
  align-items: center;

  &-file {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 33px;
    min-height: 33px;
    max-width: 33px;
    max-height: 33px;
    padding: 9px;
    border: 1px dashed $color-mercury;
    box-sizing: border-box;
    border-radius: 5px;
    color: $color-accent;
    font-size: 15px;
    transition: 0.3s;
    cursor: pointer;
    //
    //&_loading {
    //  justify-content: flex-start;
    //}

    &:hover {
      color: $color-accent-hover;
    }

    &__loading {
      width: 100%;
      height: 3px;
      background-color: $color-accent;
      border-radius: 1px;
      transition: 0.3s;
      animation: loader 1.5s linear infinite;
    }
  }

  &-text {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    min-height: 33px;
    margin-left: 8px;
    font-weight: 500;
    font-size: 12px;
    white-space: nowrap;
    color: $color-silver-chalice;
    transition: 0.3s;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    &__input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-size: 0;
      cursor: pointer;
      overflow: hidden;
      opacity: 0;
      z-index: 1;
    }
  }

  &__popup {
    position: absolute;
    left: 41px;
    top: 33px
  }
}

@keyframes loader {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/UploadFileForm/UploadFileForm.vue